import { WagmiAdapter } from "@reown/appkit-adapter-wagmi";
import { base, baseSepolia } from "@reown/appkit/networks";
import { createAppKit } from "@reown/appkit/react";
import type { ReactNode } from "react";
import { WagmiProvider } from "wagmi";

const projectId = import.meta.env.VITE_REOWN_PROJECT_ID;

const metadata = {
	name: "shiny listing",
	description: "AppKit Example",
	url: "https://reown.com/appkit",
	icons: ["https://assets.reown.com/reown-profile-pic.png"],
};

const networks =
	import.meta.env.VITE_NODE_ENV === "production" ? [base] : [baseSepolia];

const wagmiAdapter = new WagmiAdapter({
	networks,
	projectId,
	ssr: true,
});

createAppKit({
	adapters: [wagmiAdapter],
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	networks: networks as any,
	projectId,
	metadata,
	features: {
		analytics: false,
		email: false,
		socials: false,
		emailShowWallets: false,
	},
	themeMode: "light",
	themeVariables: {
		"--w3m-accent": "#7950f2",
	},
	allWallets: "HIDE",
	enableWalletGuide: false,
});

export function WalletProvider({ children }: { children: ReactNode }) {
	return (
		<WagmiProvider config={wagmiAdapter.wagmiConfig}>{children}</WagmiProvider>
	);
}
